import axios from 'axios';

//const API_URL = 'http://localhost:8080/auth';  // Adjust API URL if necessary
const API_URL = process.env.REACT_APP_API_URL + 'auth'; 

// Signup function
export const signup = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/signup`, userData, {
      headers: {
        'Content-Type': 'application/json'  // Ensure content type is application/json
      }
    });
    return response.data;  // Success response after signup
  } catch (error) {
    if (error.response) {
      console.error('Error response:', error.response);
      console.error('Error data:', error.response.data);
      alert(`Signup failed: ${error.response.data.message || error.response.data}`);  // Show backend error message
    } else if (error.request) {
      console.error('Error request:', error.request);
      alert('No response received from the server.');
    } else {
      console.error('Error', error.message);
      alert('An unexpected error occurred during signup.');
    }
    throw error;
  }
};

// Login function (generates JWT token)
export const login = async (credentials) => {
  try {
    const response = await axios.post(`${API_URL}/login`, credentials, {
      headers: {
        'Content-Type': 'application/json'  // Ensure content type is application/json
      }
    });

    console.log('Response Data:', response.data);

    // Extract token and userId from the response
    const { token, userId } = response.data;

    console.log('Token:', token);

    // Ensure token is a string before storing it in localStorage
    if (typeof token === 'string') {
      localStorage.setItem('jwtToken', token);  // Store the JWT token
      localStorage.setItem('userId', userId);   // Store the user ID
    } else {
      console.error("Invalid token received:", token);
    }

    return response.data;  // Return the JWT token and userId
  } catch (error) {
    if (error.response) {
      console.error('Error response:', error.response);
      console.error('Error data:', error.response.data);
      alert(`Login failed: ${error.response.data.message || error.response.data}`);  // Show backend error message
    } else if (error.request) {
      console.error('Error request:', error.request);
      alert('No response received from the server.');
    } else {
      console.error('Error', error.message);
      alert('An unexpected error occurred during login.');
    }
    throw error;
  }
};

// Fetch user details by userId
export const fetchUserDetails = async (userId) => {
  try {
    const token = localStorage.getItem('jwtToken');
    const response = await axios.get(`${API_URL}/user/${userId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    return response.data; // Returns user details (name, email, etc.)
  } catch (error) {
    console.error('Error fetching user details:', error);
    throw error;
  }
};

// Send a password reset link (this will send an email)
export const sendPasswordResetLink = async (emailData) => {
  try {
    // Ensure the email field is included in the email body
    const emailBody = {
      to: emailData.email, // this ensures that the email is included in the payload
      subject: "Password Reset Request",
      text: 
      `
    <html>
      <body style="font-family: Arial, sans-serif; background-color: #f4f4f9; padding: 20px; color: #333;">
        <div style="max-width: 600px; margin: 0 auto; background-color: #ffffff; padding: 20px; border-radius: 8px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);">
          <h2 style="color: #4CAF50;">Password Reset Request</h2>
          <p style="font-size: 1.1rem;">Dear user,</p>
          <p style="font-size: 1rem; line-height: 1.6;">
            We received a request to reset your password. If you made this request, please click the link below to reset your password.
          </p>
          <p style="font-size: 1rem; line-height: 1.6;">
            <a href="http://localhost:3000/auth/reset-password/" style="background-color: #4CAF50; color: white; padding: 12px 20px; text-decoration: none; border-radius: 5px; font-weight: bold;">Reset Your Password</a>
          </p>
          <p style="font-size: 0.9rem; color: #888;">
            If you did not request a password reset, please ignore this email or contact support if you have any concerns.
          </p>
          <p style="font-size: 0.9rem; color: #888;">
            Best regards,<br>
            Your Company Name
          </p>
        </div>
      </body>
    </html>
      `
    };

    // Check if email exists before sending the request
    if (!emailData.email) {
      throw new Error("Email is required.");
    }

    const response = await axios.post(`${API_URL}/send-email`, emailBody, {
      headers: {
        'Content-Type': 'application/json'  // Ensure content type is application/json
      }
    });

    return response.data;  // This will contain a success message
  } catch (error) {
    console.error('Error:', error.response || error);

    // Display a meaningful alert if email is missing
    if (error.message === "Email is required.") {
      alert("Please provide a valid email address.");
    } else if (error.response && error.response.data) {
      alert(`Error: ${error.response.data.message || error.response.data}`);
    } else {
      alert('An unexpected error occurred.');
    }

    throw error;
  }
};


// Reset password using the token received from the reset link
export const resetPassword = async (token, newPassword) => {
  try {
    // Assuming backend is ready to accept token and new password to reset it
    const response = await axios.post(`${API_URL}/reset-password`, { token, newPassword });
    return response.data;  // Response will contain success message
  } catch (error) {
    console.error('Error:', error.response || error);
    throw error;
  }
};